<template>
    <sys-register-base 
        :loading="loading" 
        @onSave="save" 
        :model.sync="model" 
        :title="title" 
        :icon="icon" 
        v-bind:show.sync="dialog"
        maxWidth="50%"
    >
        <template v-slot:form>
            <v-container>
                <v-row>
                    <v-col cols="12" sm="8">
                        <v-text-field autofocus :error="!!errors.name" :error-messages="errors.name" v-model="model.name" label="Nome*"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-text-field :error="!!errors.type" :error-messages="errors.type" v-model="model.type" label="Tipo*"></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" sm="6">
                        <SysSelectEventScope
                            :model.sync="model.event_scope_id" 
                            :error="errors.event_scope_id && errors.length > 0"  
                            :errors="errors.event_scope_id"
                            label="Escopo do Evento*"
                        />
                    </v-col>
                    <v-col cols="12" sm="3">
                        <v-text-field :error="!!errors.day" :error-messages="errors.day" v-model="model.day" label="Dia*"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3">
                        <v-text-field :error="!!errors.month" :error-messages="errors.month" v-model="model.month" label="Mês*"></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" sm="4">
                        <s-switch inset text-helper="A data de um evento não letivo não será considerado como dia de aula no diário de aula do professor" v-model="model.school_day" label="Evento Letivo" />
                    </v-col>
                    <v-col cols="12" sm="4">
                        <s-switch inset text-helper="Permitir Edição quando o usuário criar um novo evento" v-model="model.allow_editing" color="purple" label="Permitir Edição" />
                    </v-col>
                    <v-col cols="12" sm="4">
                        <sys-color-base v-bind:color.sync="model.color"/>
                    </v-col>
                </v-row>
                <v-row>
                <v-row>
                    <v-col cols="12">
                        <v-textarea
                            v-model="model.details"
                            outlined
                            name="input-7-4"
                            label="Detalhes"
                            :auto-grow="false"
                            :error="errors.length > 0"  
                            :error-messages="errors.details"
                            :value="model.details"
                        ></v-textarea>
                    </v-col>
                </v-row>

                </v-row>
            </v-container>
            <!-- Alert para mensagens -->
            <emc-alert-snackbar :show="!! message.length"  :message="message" :color="error ? 'error' : 'success'"/>
        </template>
    </sys-register-base>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
    name: "SysRegisterEventCalendarBase",
    data: (vm) => ({
        dialog: false,
        error: false,
        errors: {},
        message: '',
        loading: false,
        
    }),
    created(){
       
    },

    computed: {
      ...mapState('auth', ['acesso']),
    },

    watch: {
        
        dialog(dialog_new, dialog_old) {
            
            if(dialog_new !== dialog_old) {
                this.$emit('update:show', dialog_new)
            }

        },

        show(show_new, show_old) {
            
            this.dialog = show_new;
            
            if(show_new){
                this.error = false;
                this.errors = {};

                if(!this.model.id){
                    this.model.school_day = 1;
                    this.model.allow_editing = 1;
                }
            }
        },
        
    },
    props: {
        model: {
            default: null
        },
        color: {
            type: String,
            default: 'grey lighten-5'
        },
        width: {
            type: String,
            default: "500"
        },
        maxWidth: {
            type: String,
            default: "80%"
        },
        icon: {
            type: String,
            default: "mdi-calendar-star"
        },
        title: {
            type: String,
            default: "Evento Base"
        },
        text: {
            type: String,
            default: ""
        },
        show: {
            type: Boolean,
            default: false
        }
    },
    methods:{
        ...mapActions('eventCalendarBase', ['ActionUpdateEventCalendarBase', 'ActionCreateEventCalendarBase']),

        save(edit)
        {
            this.error = false;
            this.message = '';
            this.loading = true;

            Object.assign(this.model, {country_id: 1});

            if(edit) {
                this.ActionUpdateEventCalendarBase(this.model)
                .then((res) => {
                    this.message = res.message;
                    this.$emit('onCompleted');
                })
                .catch((error) =>{
                    this.error      = true;
                    this.errors     = error.errors;
                    this.message    = error.message;
                })
                .finally(() => {
                     this.loading = false;
                })
            } else {
                this.ActionCreateEventCalendarBase(this.model)
                .then((res) => {
                    this.message = res.message;
                    this.$emit('onCompleted', res.data);
                })
                .catch((error) =>{
                    this.error      = error;
                    this.errors     = error.errors;
                    this.message    = error.message;
                })
                .finally(() => {
                   this.loading = false;
                })

            }
        },

    }
}
</script>